import axios from "axios";
import { handleSuccessOne, handleErrorOne } from "@store/action/GlobalAction";
import {
  getAllWidgetsQuery,
  geWidgetsByTypeIdQuery,
} from "../../../graphQl/querys/widgetsQuerys";
import {
  updatewidgetMutation,
  createWidgetMutatuion,
  toggleWidgetStatusMutation,
  deleteWidgetMutation,
  createWidgetMutationInfo,
  setWidgetToreachableMutation,
  toggleWidgetCreedStatusMutation,
  updatewidgetCreedMutation,
  deleteWidgetCreedMutation,
} from "../../../graphQl/mutations/widgetsMutation";

const API = process.env.REACT_APP_QUIZZ_ENDPOINT;

const QueryEndpoint = process.env.REACT_APP_QUERY_ENDPOINY;

export const GetAllWidgets = async (disptach) => {
  let res = await axios.post(`${API}/${QueryEndpoint}`, {
    query: getAllWidgetsQuery(),
  });

  disptach({
    type: "GET_ALL_WIDGETS",
    data: res.data.data,
  });
};

export const GetAllWidgetssync = async (disptach, data, callback) => {
  let res = await axios.post(`${API}/${QueryEndpoint}`, {
    query: getAllWidgetsQuery(),
  });
  callback(data, res.data.data.getAllTypeWidget);
  disptach({
    type: "GET_ALL_WIDGETS",
    data: res.data.data,
  });
};

export const GetAllWidgethoroscop = async (disptach, callback) => {
  let res = await axios.post(`${API}/${QueryEndpoint}`, {
    query: getAllWidgetsQuery(),
  });
  callback(res.data.data.getAllTypeWidget);
  disptach({
    type: "GET_ALL_WIDGETS",
    data: res.data.data,
  });
};

export const createWidget = async (createInput, disptach) => {
  try {
    let res = await axios.post(`${API}/${QueryEndpoint}`, {
      query: createWidgetMutatuion(createInput),
    });
    GetAllWidgets(disptach);
    handleSuccessOne("Widget created successfully");
  } catch (err) {}
};

export const toggleWidgetStatus = async (id, disptach) => {
  try {
    const res = await axios.post(`${API}/${QueryEndpoint}`, {
      query: toggleWidgetStatusMutation(id),
    });

    handleSuccessOne("widget status updated successfully");
    setTimeout(() => GetAllWidgets(disptach), 250);
  } catch (err) {}
};

export const deleteWidget = async (id, disptach) => {
  try {
    const res = await axios.post(`${API}/${QueryEndpoint}`, {
      query: deleteWidgetMutation(id),
    });

    handleSuccessOne("widget deleted successfully");
    setTimeout(() => GetAllWidgets(disptach), 250);
  } catch (err) {}
};

export const updateWidget = async (id, updateDto, disptach, t) => {
  try {
    const res = await axios.post(`${API}/${QueryEndpoint}`, {
      query: updatewidgetMutation(id, updateDto),
    });

    if (res.status === 200) {
      handleSuccessOne(t("widget updated successfully"));
      setTimeout(() => GetAllWidgets(disptach), 250);
    } else {
      handleErrorOne("error");
    }
  } catch (err) {}
};

export const getWidgetsByTypeId = async (id, disptach) => {
  try {
    const res = await axios.post(`${API}/${QueryEndpoint}`, {
      query: geWidgetsByTypeIdQuery(id),
    });

    disptach({
      type: "GET_WIDGETS_BY_TYPE_ID",
      data: res.data.data.getWidgetByType,
    });

    setTimeout(() => GetAllWidgets(disptach), 250);
  } catch (err) {}
};

export const createWidgetInfo = async (id, createInput, disptach) => {
  try {
    let res = await axios.post(`${API}/${QueryEndpoint}`, {
      query: createWidgetMutationInfo(createInput),
    });

    getWidgetsByTypeId(id, disptach);
    handleSuccessOne("Widget info created successfully");
  } catch (err) {}
};

export const toggleWidgetStatus2 = async (id, disptach) => {
  try {
    const res = await axios.post(`${API}/${QueryEndpoint}`, {
      query: toggleWidgetStatusMutation(id),
    });

    setTimeout(() => getWidgetsByTypeId(id, disptach), 150);
    getWidgetsByTypeId(id, disptach);
    handleSuccessOne("widget status updated successfully");
  } catch (err) {}
};

export const toggleWidgetToReachable = async (type_id, widget_id, disptach) => {
  try {
    const res = await axios.post(`${API}/${QueryEndpoint}`, {
      query: setWidgetToreachableMutation(type_id, widget_id),
    });

    setTimeout(
      () => {
        getWidgetsByTypeId(type_id, disptach);
        handleSuccessOne("widget status updated successfully");
      },

      110
    );
  } catch (err) {}
};

export const toggleWidgetCreedStatus = async (id, type_id, disptach) => {
  try {
    const res = await axios.post(`${API}/${QueryEndpoint}`, {
      query: toggleWidgetCreedStatusMutation(id),
    });

    setTimeout(
      () => {
        getWidgetsByTypeId(type_id, disptach);
        handleSuccessOne("widget status updated successfully");
      },

      110
    );
  } catch (err) {}
};

export const deleteWidgetCreedStatus = async (id, type_id, disptach) => {
  try {
    const res = await axios.post(`${API}/${QueryEndpoint}`, {
      query: deleteWidgetCreedMutation(id),
    });

    setTimeout(
      () => {
        getWidgetsByTypeId(type_id, disptach);
        handleSuccessOne("widget status updated successfully");
      },

      110
    );
  } catch (err) {}
};

export const updateWidgetCreed = async (id, Dto, type_id, disptach) => {
  try {
    const res = await axios.post(`${API}/${QueryEndpoint}`, {
      query: updatewidgetCreedMutation(id, Dto),
    });

    setTimeout(
      () => {
        getWidgetsByTypeId(type_id, disptach);
        handleSuccessOne("widget status updated successfully");
      },

      210
    );
  } catch (err) {}
};
